import { Button, CircularProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react'
import FacilityBooking from './FacilityBooking'
import RefundReport from './RefundReport'
import DepositReport from './DepositReport'
import { ReactComponent as DownloadIcon } from "../../../Icons/DownloadIcon.svg";
import { PrimaryTypography, StyledSecondaryServiceTypography } from '../../../Theme';
import { useSelector } from 'react-redux';

function FacilityBookingHistory() {

    const { LanguageData } = useSelector((state) => state.Language);
    const tabList = ["Facility Report", "Refund Report", "Deposit Report"];
    const [selectedTab, setSelectedTab] = useState("Facility Report");
    const [TabId, setTabId] = useState("");

  return (
    <>

        {selectedTab === "Facility Report" && (
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box>
              <PrimaryTypography>
                {LanguageData?.Facility_Booking_History || "Facility Booking History"}
              </PrimaryTypography>
              <StyledSecondaryServiceTypography>
                View a detailed log of all past facility bookings, including payment, deposit, and refund status.
              </StyledSecondaryServiceTypography>
            </Box>
            {/* {UserManage?.booking && ( */}
              <Box>
                <Button
                //   onClick={(e) => setDownloadAnchorEl(e.currentTarget)}
                  sx={{
                    fontWeight: "600",
                    width: "fit-content",
                    color: "#0E5E84",
                    backgroundColor: "#E7EFF3",
                    padding: "10px 16px 10px 16px",
                    "&:hover": {
                      backgroundColor: "#CFDFE6",
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#F9FAFB",
                      color: "#D2D6DB",
                    },
                  }}
                //   disabled={bookingFacilityDetails.length === 0 || loading}
                >
                  {/* {loading ? (
                    <Box sx={{ width: "40px", marginTop: "5px" }}>
                      <CircularProgress size={15} />
                    </Box>
                  ) : (
                    <>
                      {bookingFacilityDetails.length > 0 ? (
                        <DownloadIcon
                          style={{ marginRight: "8px", padding: "3px" }}
                        />
                      ) : (
                        <DisabledDownloadIcon
                          style={{ marginRight: "8px", padding: "3px" }}
                        />
                      )}
                    </>
                  )} */}
                  <DownloadIcon
                          style={{ marginRight: "8px", padding: "3px" }}
                        />
                  {LanguageData?.home_download_report || "Download Report"}
                </Button>
              </Box>
             {/* )} */}
          </Box>
        )}

        {selectedTab === "Refund Report" && (
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box>
              <PrimaryTypography>
                {LanguageData?.Refund_Report || "Refund Report"}
              </PrimaryTypography>
              <StyledSecondaryServiceTypography>
                View refunded amounts from facility bookings, including deposits and cancellations.
              </StyledSecondaryServiceTypography>
            </Box>
            {/* {UserManage?.booking && ( */}
              <Box>
                <Button
                //   onClick={(e) => setDownloadAnchorEl(e.currentTarget)}
                  sx={{
                    fontWeight: "600",
                    width: "fit-content",
                    color: "#0E5E84",
                    backgroundColor: "#E7EFF3",
                    padding: "10px 16px 10px 16px",
                    "&:hover": {
                      backgroundColor: "#CFDFE6",
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#F9FAFB",
                      color: "#D2D6DB",
                    },
                  }}
                //   disabled={bookingFacilityDetails.length === 0 || loading}
                >
                  {/* {loading ? (
                    <Box sx={{ width: "40px", marginTop: "5px" }}>
                      <CircularProgress size={15} />
                    </Box>
                  ) : (
                    <>
                      {bookingFacilityDetails.length > 0 ? (
                        <DownloadIcon
                          style={{ marginRight: "8px", padding: "3px" }}
                        />
                      ) : (
                        <DisabledDownloadIcon
                          style={{ marginRight: "8px", padding: "3px" }}
                        />
                      )}
                    </>
                  )} */}
                  <DownloadIcon
                          style={{ marginRight: "8px", padding: "3px" }}
                        />
                  {LanguageData?.home_download_report || "Download Report"}
                </Button>
              </Box>
             {/* )} */}
          </Box>
        )}


        {selectedTab === "Deposit Report" && (
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box>
              <PrimaryTypography>
                {LanguageData?.Deposit_Report || "Deposit Report"}
              </PrimaryTypography>
              <StyledSecondaryServiceTypography>
                View and track all deposit payments made for facility bookings, including their refund status.
              </StyledSecondaryServiceTypography>
            </Box>
            {/* {UserManage?.booking && ( */}
              <Box>
                <Button
                //   onClick={(e) => setDownloadAnchorEl(e.currentTarget)}
                  sx={{
                    fontWeight: "600",
                    width: "fit-content",
                    color: "#0E5E84",
                    backgroundColor: "#E7EFF3",
                    padding: "10px 16px 10px 16px",
                    "&:hover": {
                      backgroundColor: "#CFDFE6",
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#F9FAFB",
                      color: "#D2D6DB",
                    },
                  }}
                //   disabled={bookingFacilityDetails.length === 0 || loading}
                >
                  {/* {loading ? (
                    <Box sx={{ width: "40px", marginTop: "5px" }}>
                      <CircularProgress size={15} />
                    </Box>
                  ) : (
                    <>
                      {bookingFacilityDetails.length > 0 ? (
                        <DownloadIcon
                          style={{ marginRight: "8px", padding: "3px" }}
                        />
                      ) : (
                        <DisabledDownloadIcon
                          style={{ marginRight: "8px", padding: "3px" }}
                        />
                      )}
                    </>
                  )} */}
                  <DownloadIcon
                          style={{ marginRight: "8px", padding: "3px" }}
                        />
                  {LanguageData?.home_download_report || "Download Report"}
                </Button>
              </Box>
             {/* )} */}
          </Box>
        )}

    <Box
              sx={{
                border: "1px solid #D2D6DB",
                display: "flex",
                borderRadius: "10px",
                width : '400px',
                mt : 2.5,
                backgroundColor : '#F9FAFB'
              }}
            >
              {tabList.map((value, index) => (
                <Box
                  key={index}
                  onClick={() => {
                    setSelectedTab(value);
                    setTabId(index == 0 ? "" : index);
                    console.log("tabl", tabList);
                    // if (value == "Offboarding") {
                    //   setStatusId("offboarding_status=1");
                    // } else if (value === "Inactive") {
                    //   setStatusId("statusId=2,3");
                    // } else if (value === "Active") {
                    //   setStatusId("statusId=1");
                    // } else {
                    //   setStatusId("statusId=0");
                    // }
                  }}
                  sx={{
                    borderLeft: "1px solid #E5E7EB",
                    padding: "10px 16px",
                    backgroundColor:
                      value == selectedTab ? "#FFFFFF" : "initial",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius:
                      index === 3
                        ? "0px 8px 8px 0px"
                        : index === 0
                        ? "8px 0px 0px 8px"
                        : "initial",
                    "&:hover": { cursor: "pointer" },
                  }}
                >
                  <Typography
                    sx={{
                      color: value === selectedTab ? "#111927" : "#4D5761",
                      fontSize: "14px",
                      fontWeight: 550,
                    }}
                    textAlign={"center"}
                  >
                    {value}
                  </Typography>
                </Box>
              ))}
            </Box>
        {selectedTab === "Facility Report" && <FacilityBooking />}
        {selectedTab === "Refund Report" && <RefundReport />}
        {selectedTab === "Deposit Report" && <DepositReport />}
    </>
  )
}

export default FacilityBookingHistory